import { BlobServiceClient } from "@azure/storage-blob";
import axios from "axios";

// Upload file
async function uploadFile(file, orgId, form, id, storedUser) {
  if (file.size > 5*1024*1024) {
    alert("File size exceeds 5 MB limit")
    throw new Error("File size exceeds 5 MB limit");
  }

  const allowedTypes = [
    // PDF
    "application/pdf",

    // Images
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp",

    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx

    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // .xlsx
  ];

  if (!allowedTypes.includes(file.type)) {
    alert("Only PDF, Images, Word, and Excel files are allowed");
    throw new Error("Unsupported file type: " + file.type);
  }
  
  const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/file/generate-sas`, {
    headers: { Authorization: `Bearer ${storedUser.accessToken}` },
  });
  const sasUrl = res.data;

  // 2. Init Azure client with SAS
  const blobServiceClient = new BlobServiceClient(sasUrl);
  const containerClient = blobServiceClient.getContainerClient("");

  // 3. Create unique blob name
  let blobName;
  if(id === null){
    blobName = `nobel-eApproval/${orgId}/${Date.now()}-${file.name}`;
  } else {
    blobName = `nobel-eApproval/${orgId}/${form}/${id}/${Date.now()}-${file.name}`;
  }
  const blockBlobClient = containerClient.getBlockBlobClient(blobName);

  // 4. Upload file
  const contentType = file.type || 
  (file.name.endsWith(".pdf") ? "application/pdf" : "application/octet-stream");

  await blockBlobClient.uploadData(file, {
    blobHTTPHeaders: { blobContentType: contentType },
  });

  return `${sasUrl.split("?")[0]}/${blobName}`;
}

export { uploadFile };
